import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import {
  merchantJwtClient,
  jwtApiClient,
} from "@/apps/merchant3/services/apiClient/apiClient";
import { IMerchantWrap } from "@/apps/merchant3/models/IResponse";

export const getMerchant = async (): Promise<AxiosResponse<IMerchantWrap>> => {
  return await merchantJwtClient.get(M3_API().GET_MERCHANT);
};

export const getMerchantByClerk = async (): Promise<
  AxiosResponse<IMerchantWrap>
> => {
  return await jwtApiClient.get(M3_API().GET_MERCHANT);
};

export const getSupportedModels = async (): Promise<AxiosResponse> => {
  return await merchantJwtClient.get(M3_API().MERCHANT_SUPPORTED_MODELS);
};

export const getLatestReceipts = async (
  days?: number
): Promise<AxiosResponse> => {
  return await jwtApiClient.get(
    M3_API().MERCHANT_LATEST_RECEIPTS,
    days
      ? {
          params: {
            days: days,
          },
        }
      : undefined
  );
};
